// @flow

import {Validator, ValidatorResult} from "jsonschema";

class SchemaValidator {

    schema: {};
    validator: Validator;
    result: ValidatorResult;

    /**
     *
     * @param {object} schema
     */
    constructor(schema) {
        this.schema = schema;
        /**
         * @type {Validator}
         */
        this.validator = new Validator();
        /**
         * @type {ValidatorResult}
         */
        this.result = null;
    }

    /**
     *
     * @param {object} instance
     * @returns {boolean}
     */
    validate(instance) {
        this.result = this.validator.validate(instance, this.schema);
        return this.result.valid;
    }

    /**
     *
     * @returns {boolean}
     */
    isValid() {
        return this.result.valid;
    }

    /**
     *
     * @returns {ValidationError[]}
     */
    errors() {
        return this.result.errors;
    }
}

export default SchemaValidator;
